import type { WarehouseRes } from 'api/swagger';

export const transformWarehousesForForm = (
  warehouses?: WarehouseRes[],
  initialValue?: number | null,
): { value: number; label: string }[] => {
  if (!warehouses) return [];

  const filteredWarehouses = warehouses.filter((warehouse) => {
    if (!warehouse.deprecated) return true;

    if (initialValue && warehouse.deprecated && warehouse.id === initialValue) return true;

    return false;
  });

  return filteredWarehouses.map((warehouse) => ({
    value: warehouse.id,
    label: warehouse.name,
  }));
};
